module.exports = __webpack_public_path__ + "img/logo2.aadfd0dc.png";